<template>
  <div class="_make-article ">
    <header class="ArticleMainHeader">
      <h1 class="ArticleMainTitle"> ตอบกลับข้อความด้วยเทมเพลต (Template)</h1>
    </header>
    <div class="MarkdownContent">
      <p class="preindent">เป็น API ที่ใช้สำหรับการส่งเทมเพลต หาบุคคลอื่นแบบหลายห้องแชทในคราวเดียว โดยทำการกำหนดห้องแชทที่ต้องการส่งถึงเป็นแบบลิสต์</p>
    </div>

    <header class="EndpointHeader">
      <h2 class="EndpointTitle">
        API ส่งเทมเพลต (หลายห้องแชท)
      </h2>
      -
      <span class="EndpointVerbPost">
        POST
      </span>
      <span class="EndpointUrl">
        {{urlsendmsg}}
   <!-- https://chat-api.one.th/bc_msg/api/v1/broadcast_group -->
           <v-icon class="urlcopymessage" style="color:black; font-size: 13px !important; cursor: pointer;" v-clipboard:copy="urlsendmsg">file_copy</v-icon>
      </span>
    </header>

    <div class="MarkdownContent hidden-sm-and-down">
      <h3>Request Header</h3>
      <code class="codecolor">
        <span class="colorkey">"Authorization"</span> : <span class="colorvalue">"Bearer Axxxxxxx…."</span>
      </code>
      <!-- <p class="preindent">ทุกครั้งที่ทำการติดต่อ API กับทางOneChat ต้องส่ง Authorization มาใน Header ทุกครั้ง </p> -->
      <h3>Request Parameter (JSON)</h3>
      <code class="codecolor">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessage"
              v-clipboard:copy="message">
          <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
        </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"bot_id"</span> : <span class="colorvalue">"B6a84xxxa85f1fad2xxxxccfa703"</span>,
    <span class="colorkey">"to"</span> : <span class="colorvalue">["121xxx20x4","196xxxx23xx6"]</span>,
    <span class="colorkey">"elements"</span> : [
      {
        <span class="colorkey">"image"</span> : <span class="colorvalue">"https://onechat.one.th/xxxxxxxxxxx.jpg"</span>,
        <span class="colorkey">"detail"</span> : <span class="colorvalue">"Pizza"</span>,
        <span class="colorkey">"title"</span> : <span class="colorvalue">"Pizza ถาดกลาง 250฿"</span>,
        <span class="colorkey">"choice"</span> : [
           {
             <span class="colorkey">"url"</span> : <span class="colorvalue">"https://chat.one.th"</span>,
             <span class="colorkey">"sign"</span> : <span class="colorvalue">"true"</span>,
             <span class="colorkey">"size"</span> : <span class="colorvalue">"tall"</span>,
             <span class="colorkey">"type"</span> : <span class="colorvalue">"webview"</span>,
             <span class="colorkey">"label"</span> : <span class="colorvalue">"One Chat"</span>
           },
           {....รูปแบบปุ่มต่างๆ....}
        ]
      },
      ...
    ]
  }
        </code>

    <!-- <h3>รายละเอียดข้อมูลที่ใช้ในการส่งข้อความ</h3> -->
      <table id="apimsgtable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>จำเป็น (Required)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>bot_id</td>
          <td>String</td>
          <td style="text-align: center;">✅</td>
          <td>รหัสเฉพาะตัวของ Bot ที่จะทำการส่งข้อความนี้</td>
        </tr>
        <tr>
          <td>to</td>
          <td>array String</td>
          <td style="text-align: center;">✅</td>
          <td>ลิสต์ Oneid ของผู้รับข้อความ</td>
        </tr>
        <tr>
          <td>elements</td>
          <td>array Json</td>
          <td style="text-align: center;">✅</td>
          <td>ลิสต์ Json ของข้อมูลแต่ละกล่องข้อความ ขนาดไม่เกิน 10 Json Object</td>
        </tr>
        <tr>
          <td>image</td>
          <td>string</td>
          <td style="text-align: center;">✅</td>
          <td>Url รูปภาพที่จะแสดงบนกล่องข้อความนี้</td>
        </tr>
        <tr>
          <td>choice</td>
          <td>array Json</td>
          <td style="text-align: center;">✅</td>
          <td>ลิสต์ข้อมูลของปุ่มที่จะให้แสดงบนข้อความนี้ ขนาดไม่เกิน 4 Json Object ประกอบด้วยข้อมูลดังนี้
            <ul><li>url คือ url ที่จะทำการเปิดเมื่อทำการกดปุ่ม</li>
            <li>sign คือ ที่การต่อ shared token ของ Oneid ไปท้าย url เมื่อทำการเปิด (string true หรือ false เท่านั้น)</li>
            <li>size คือ ขนาดของ webview เมื่อทำการเปิด (compact tall หรือ full) **ไม่มีผลเมื่อเป็นปุ่ม type link**</li>
            <li>type คือ ข้อมูล ประเภท action ของปุ่มเมื่อทำการกด สามารถดูตัวอย่างเพิ่มเติมเกี่ยวกับปุ่มแต่ละประเภทได้ที่
              <a @click="gotopart()">ดูการใช้งานเพิ่มเติมที่ <i class="fas fa-info-circle iconSizeWebview"></i></a>
            </li>
            <li>label คือ ข้อความที่จะแสดงบนปุ่มไม่เกิน 15 ตัวอักษร</li>
            </ul>
          </td>
        </tr>
      </table>

<!-- 200OK -->
      <br>
        <header class="EndpointHeader">
          <h2 class="EndpointTitle">
            Response (JSON)
          </h2>
          -<span class="EndpointVerbPost">200 OK</span>
          <span class="EndpointUrl">
            กรณีที่ส่ง request มาถูกต้อง
          </span>
        </header>
        <code class="codecolor">
          <v-tooltip top>
            <v-btn flat icon type="button" style="float: right;"
              slot="activator" class="requestmessageresponse"
              v-clipboard:copy="messageresponse">
              <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
            </v-btn>
            <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"success"</span>
  }
        </code>

<!-- <h3>รายละเอียดข้อมูลที่ได้จากการส่งข้อความ</h3> -->
      <table id="apimsgtable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>success แสดงว่าการทำงานใน API นั้นสมบูรณ์
          </td>
        </tr>
      </table>

<!-- eroor response  -->
     <!-- authorization fail -->
      <br>
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (string)</h2>-<span class="EndpointVerberror">401 UNAUTHORIZED</span>
        <span class="EndpointUrl">กรณีไม่ทำการส่ง Authorization มากับ Request Header</span>
      </header>
      <code class="codecolor">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageerror_no_auth">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
<br>
    <span>authorization_fail</span>
    <!-- <span class="colorkey">"message"</span> : <span class="colorvalue">"parameter to out of range."</span> -->
<br>
      </code>
      <!-- <table id="apimsgtable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>authorization_fail แสดงว่าไม่ทำการส่ง Authorization มากับ Request Header
          </td>
        </tr>
      </table> -->

<!-- Authorization wrong format -->
      <br>
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>-<span class="EndpointVerberror">401 UNAUTHORIZED</span>
        <span class="EndpointUrl">กรณีรูปแบบของ Authorization ผิด</span>
      </header>
      <code class="codecolor">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageerror_wrong_auth">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"Authorization wrong format."</span>
  }
      </code>
      <table id="apimsgtable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>รูปแบบของ Authorization ผิด
          </td>
        </tr>
      </table>

<!--  -->
      <br>
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>-<span class="EndpointVerberror">401 UNAUTHORIZED</span>
        <span class="EndpointUrl">กรณีAuthorization ที่ส่งมาไม่มีในระบบ หรือไม่มีสิทธิ์ในการใช้กับ Bot ตัวที่ระบุมาใน Request</span>
      </header>
      <code class="codecolor">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageerror_fail_auth">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">401</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"authorization_failed"</span>
  }
      </code>
      <table id="apimsgtable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>-</td>
          <td>401
                      <!-- <td>401 แสดงว่าการทำงานใน API นั้นไม่สำเร็จ -->
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>Authorization ที่ส่งมาไม่มีในระบบ หรือไม่มีสิทธิ์ในการใช้กับ Bot ตัวที่ระบุมาใน Request
          </td>
        </tr>
      </table>

<!--  -->
      <br>
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (string)</h2>-
        <span class="EndpointVerberror">400 BAD REQUEST</span>
        <span class="EndpointUrl">กรณีส่ง Parameter มาไม่ครบ</span>
      </header>
      <code class="codecolor">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageerror_missing_parameter">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
          <br>
          <span class="">missing_parameter</span>
          <br>
      </code>

<!--  -->
      <br>
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>
        <span class="EndpointUrl">กรณีจำนวนผู้รับมีมากกว่า 100 คน</span>
      </header>
      <code class="codecolor">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageerror_out_of_range">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"to out of range"</span>
  }
      </code>
      <table id="apimsgtable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>จำนวนผู้รับ(to) มีมากกว่า 100 คน
          </td>
        </tr>
      </table>

<!--  -->
      <br>
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>
        <span class="EndpointUrl">กรณีไม่พบข้อมูลของ bot_id ที่ส่งมาในระบบ</span>
      </header>
      <code class="codecolor">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageerror_no_botid">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"Not found bot."</span>
  }
      </code>
      <table id="apimsgtable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>ไม่พบข้อมูลของ bot_id ที่ส่งมาในระบบ
          </td>
        </tr>
      </table>

<!--  -->
      <br>
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>
        <span class="EndpointUrl">กรณีชนิดของตัวแปร title ที่ส่งมาผิดประเภท</span>
      </header>
      <code class="codecolor">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageerror_wrong_title">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"type title error"</span>
  }
      </code>
      <table id="apimsgtable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>ชนิดของตัวแปร title ที่ส่งมาผิดประเภท
          </td>
        </tr>
      </table>

<!--  -->
      <br>
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>
        <span class="EndpointUrl">กรณีชนิดของตัวแปร detail  ที่ส่งมาผิดประเภท</span>
      </header>
      <code class="codecolor">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageerror_wrong_detail">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"type detail error"</span>
  }
      </code>
      <table id="apimsgtable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>ชนิดของตัวแปร detail ที่ส่งมาผิดประเภท
          </td>
        </tr>
      </table>

<!--  -->
      <br>
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>
        <span class="EndpointUrl">กรณีชนิดของตัวแปร choice  ที่ส่งมาผิดประเภท</span>
      </header>
      <code class="codecolor">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageerror_wrong_choice">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"type choice error"</span>
  }
      </code>
      <table id="apimsgtable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>ชนิดของตัวแปร choice ที่ส่งมาผิดประเภท
          </td>
        </tr>
      </table>

      <!--  -->
      <br>
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>
        <span class="EndpointUrl">กรณีขนาดของตัวแปร title ที่ส่งมามีขนาดเกินที่กำหนด</span>
      </header>
      <code class="codecolor">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageerror_title_range">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"title out of range"</span>
  }
      </code>
      <table id="apimsgtable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>ขนาดของตัวแปร title ที่ส่งมามีขนาดเกินที่กำหนด
          </td>
        </tr>
      </table>

      <!--  -->
      <br>
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>
        <span class="EndpointUrl">กรณีขนาดของตัวแปร detail ที่ส่งมามีขนาดเกินที่กำหนด</span>
      </header>
      <code class="codecolor">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageerror_detail_range">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"detail out of range"</span>
  }
      </code>
      <table id="apimsgtable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>ขนาดของตัวแปร detail ที่ส่งมามีขนาดเกินที่กำหนด
          </td>
        </tr>
      </table>
      <!--  -->
      <br>
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>
        <span class="EndpointUrl">กรณีขนาดของตัวแปร choice ที่ส่งมามีขนาดเกินที่กำหนด</span>
      </header>
      <code class="codecolor">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageerror_choice_range">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"choice out of range"</span>
  }
      </code>
      <table id="apimsgtable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>ขนาดของตัวแปร choice ที่ส่งมามีขนาดเกินที่กำหนด
          </td>
        </tr>
      </table>
      <!--  -->
      <br>
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>
        <span class="EndpointUrl">กรณีข้อมูลบางตัวของคีย์ elements มีข้อมูลไม่ครบ</span>
      </header>
      <code class="codecolor">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageerror_missing_elements">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"elem missing parameter."</span>
  }
      </code>
      <table id="apimsgtable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>ข้อมูลบางตัวของคีย์ elements มีข้อมูลไม่ครบ (เช็คคีย์ title detail choice ของแต่ละ Json ในคีย์ elements ว่าส่งมาครบหรือไม่)</td>
        </tr>
      </table>

      <!--  -->
      <br>
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>
        <span class="EndpointUrl">กรณีไม่พบ Url ใน choice ที่เป็นประเภท link หรือ webview</span>
      </header>
      <code class="codecolor">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageerror_missing_url_choice">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"not found url in choice"</span>
  }
      </code>
      <table id="apimsgtable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>ไม่พบ Url ใน choice ที่เป็นประเภท link หรือ webview
          </td>
        </tr>
      </table>

      <!--  -->
      <br>
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>
        <span class="EndpointUrl">กรณี Type ของ choice บางตัวที่ส่งมาไม่รองรับ</span>
      </header>
      <code class="codecolor">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageerror_elmchoice_not_support">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"elem choice type not support"</span>
  }
      </code>
      <table id="apimsgtable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>Type ของ choice บางตัวที่ส่งมาไม่รองรับ
          </td>
        </tr>
      </table>


    </div>


    <!-- mobile -->
    <div class="hidden-md-and-up">
      <h3>Request Header</h3>
      <code class="codecolormo">
        <span class="colorkey">"Authorization"</span> : <span class="colorvalue">"Bearer Axxxxxxx..."</span>
      </code>
      <h3>Request Parameter (JSON)</h3>

          <code class="codecolormo">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessage"
              v-clipboard:copy="message">
          <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
        </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"bot_id"</span> : <span class="colorvalue">"B6a84xxxa85f1fad2xxxxccfa703"</span>,
    <span class="colorkey">"to"</span> : <span class="colorvalue">["121xxx20x4","196xxxx23xx6"]</span>,
    <span class="colorkey">"elements"</span> : [
      {
        <span class="colorkey">"image"</span> : <span class="colorvalue">"https://onechat.one.th/xxxxxxxxxxx.jpg"</span>,
        <span class="colorkey">"detail"</span> : <span class="colorvalue">"Pizza"</span>,
        <span class="colorkey">"title"</span> : <span class="colorvalue">"Pizza ถาดกลาง 250฿"</span>,
        <span class="colorkey">"choice"</span> : [
           {
             <span class="colorkey">"url"</span> : <span class="colorvalue">"https://chat.one.th"</span>,
             <span class="colorkey">"sign"</span> : <span class="colorvalue">"true"</span>,
             <span class="colorkey">"size"</span> : <span class="colorvalue">"tall"</span>,
             <span class="colorkey">"type"</span> : <span class="colorvalue">"webview"</span>,
             <span class="colorkey">"label"</span> : <span class="colorvalue">"One Chat"</span>
           },
           {....รูปแบบปุ่มต่างๆ....}
        ]
      },
      ...
    ]
  }
      </code>
        <!-- <h3>รายละเอียดข้อมูลที่ใช้ในการส่งข้อความ</h3> -->
     <table id="apimsgtablemo" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>จำเป็น (Required)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>bot_id</td>
          <td>String</td>
          <td style="text-align: center;">✅</td>
          <td>รหัสเฉพาะตัวของ Bot ที่จะทำการส่งข้อความนี้</td>
        </tr>
        <tr>
          <td>to</td>
          <td>array String</td>
          <td style="text-align: center;">✅</td>
          <td>ลิสต์ Oneid ของผู้รับข้อความ</td>
        </tr>
        <tr>
          <td>elements</td>
          <td>array Json</td>
          <td style="text-align: center;">✅</td>
          <td>ลิสต์ Json ของข้อมูลแต่ละกล่องข้อความ ขนาดไม่เกิน 10 Json Object</td>
        </tr>
        <tr>
          <td>image</td>
          <td>string</td>
          <td style="text-align: center;">✅</td>
          <td>Url รูปภาพที่จะแสดงบนกล่องข้อความนี้</td>
        </tr>
        <tr>
          <td>choice</td>
          <td>array Json</td>
          <td style="text-align: center;">✅</td>
          <td>ลิสต์ข้อมูลของปุ่มที่จะให้แสดงบนข้อความนี้ ขนาดไม่เกิน 4 Json Object ประกอบด้วยข้อมูลดังนี้
            <ul>
              <li>url คือ url ที่จะทำการเปิดเมื่อทำการกดปุ่ม</li>
         <li>sign คือ ที่การต่อ shared token ของ Oneid
              ไปท้าย url เมื่อทำการเปิด (string true หรือ false เท่านั้น)</li>
            <li>size คือ ขนาดของ webview เมื่อทำการเปิด (compact tall หรือ full)
              **ไม่มีผลเมื่อเป็นปุ่ม type link**</li>
            <li>type คือ ข้อมูล ประเภท action ของปุ่มเมื่อทำการกด
              สามารถดูตัวอย่างเพิ่มเติมเกี่ยวกับปุ่มแต่ละประเภทได้ที่
              <br>
              <!-- <div> -->
              <!-- <div :style="$vuetify.breakpoint.xs ? 'width:calc(100vh - 570px)' : ''"> -->
              <div v-if="$vuetify.breakpoint.width < 420 " class="wrap2" >
                <a @click="gotopart()">ดูการใช้งานเพิ่มเติมที่ <i class="fas fa-info-circle iconSizeWebview"></i></a>
              </div>
              <div v-if="$vuetify.breakpoint.width >= 420 && $vuetify.breakpoint.width < 650" class="wrap3" >
              <a :href="urlexamplebtn">{{urlexamplebtn}}</a>
              </div>
              <div v-if="$vuetify.breakpoint.width >=650" class="" >
              <a @click="gotopart()">ดูการใช้งานเพิ่มเติมที่ <i class="fas fa-info-circle iconSizeWebview"></i></a>
              </div>
              (string)</li>
               <li>label คือ ข้อความที่จะแสดงบนปุ่มไม่เกิน 15 ตัวอักษร</li>
            </ul>
          </td>
        </tr>

      </table>
      <br>
   <header class="EndpointHeader">
<h2 class="EndpointTitle">
        Response (JSON)
      </h2>-<span class="EndpointVerbPost">200 OK</span>
      <span class="EndpointUrl">
        กรณีที่ส่ง request มาถูกต้อง

      </span>
    </header>
<code class="codecolormo">
  <v-tooltip top>
<v-btn flat icon type="button" style="float: right;"
 slot="activator" class="requestmessageresponse"
      v-clipboard:copy="messageresponse">
      <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon></v-btn>
       <span>Copy to clipboard</span>
    </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"success"</span>
  }
</code>
<!-- <h3>รายละเอียดข้อมูลที่ได้จากการส่งข้อความ</h3> -->
      <table id="apimsgtablemo" style="margin-top: 2vh;">
      <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>success แสดงว่าการทำงานใน API นั้นสมบูรณ์
          </td>
        </tr>
      </table>

      <br>
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (string)</h2>-<span class="EndpointVerberror">401 UNAUTHORIZED</span>
        <span class="EndpointUrl">กรณีไม่ทำการส่ง Authorization มากับ Request Header</span>
      </header>
      <code class="codecolormo">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageerror_no_auth">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
<br>
    <span>authorization_fail</span>
    <br>
    <!-- <span class="colorkey">"message"</span> : <span class="colorvalue">"parameter to out of range."</span> -->
      </code>

      <!-- Authorization wrong format -->
      <br>
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>-<span class="EndpointVerberror">401 UNAUTHORIZED</span>
        <span class="EndpointUrl">กรณีรูปแบบของ Authorization ผิด</span>
      </header>
      <code class="codecolormo">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageerror_wrong_auth">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"Authorization wrong format."</span>
  }
      </code>
      <table id="apimsgtablemo" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>รูปแบบของ Authorization ผิด
          </td>
        </tr>
      </table>

      <br>
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>-<span class="EndpointVerberror">401 UNAUTHORIZED</span>
        <span class="EndpointUrl">กรณีAuthorization ที่ส่งมาไม่มีในระบบ หรือไม่มีสิทธิ์ในการใช้กับ Bot ตัวที่ระบุมาใน Request</span>
      </header>
      <code class="codecolormo">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageerror_fail_auth">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">401</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"authorization_failed"</span>
  }
      </code>
      <table id="apimsgtablemo" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>-</td>
          <td>401
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>Authorization ที่ส่งมาไม่มีในระบบ หรือไม่มีสิทธิ์ในการใช้กับ Bot ตัวที่ระบุมาใน Request
          </td>
        </tr>
      </table>

      <br>
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (string)</h2>-
        <span class="EndpointVerberror">400 BAD REQUEST</span>
        <span class="EndpointUrl">กรณีส่ง Parameter มาไม่ครบ</span>
      </header>
      <code class="codecolormo">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageerror_missing_parameter">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
          <br>
          <span class="">missing_parameter</span>
          <br>
      </code>

<!--  -->
      <br>
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>
        <span class="EndpointUrl">กรณีจำนวนผู้รับมีมากกว่า 100 คน</span>
      </header>
      <code class="codecolormo">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageerror_out_of_range">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"to out of range"</span>
  }
      </code>
      <table id="apimsgtablemo" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>จำนวนผู้รับ(to) มีมากกว่า 100 คน
          </td>
        </tr>
      </table>
       <br>
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>
        <span class="EndpointUrl">กรณีไม่พบข้อมูลของ bot_id ที่ส่งมาในระบบ</span>
      </header>
      <code class="codecolormo">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageerror_no_botid">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"Not found bot."</span>
  }
      </code>
      <table id="apimsgtablemo" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>ไม่พบข้อมูลของ bot_id ที่ส่งมาในระบบ
          </td>
        </tr>
      </table>

            <br>
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>
        <span class="EndpointUrl">กรณีชนิดของตัวแปร title ที่ส่งมาผิดประเภท</span>
      </header>
      <code class="codecolormo">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageerror_wrong_title">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"type title error"</span>
  }
      </code>
      <table id="apimsgtablemo" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>ชนิดของตัวแปร title ที่ส่งมาผิดประเภท
          </td>
        </tr>
      </table>

<!--  -->
      <br>
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>
        <span class="EndpointUrl">กรณีชนิดของตัวแปร detail  ที่ส่งมาผิดประเภท</span>
      </header>
      <code class="codecolormo">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageerror_wrong_detail">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"type detail error"</span>
  }
      </code>
      <table id="apimsgtablemo" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>ชนิดของตัวแปร detail ที่ส่งมาผิดประเภท
          </td>
        </tr>
      </table>


      <!--  -->
      <br>
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>
        <span class="EndpointUrl">กรณีชนิดของตัวแปร choice  ที่ส่งมาผิดประเภท</span>
      </header>
      <code class="codecolormo">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageerror_wrong_choice">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"type choice error"</span>
  }
      </code>
      <table id="apimsgtablemo" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>ชนิดของตัวแปร choice ที่ส่งมาผิดประเภท
          </td>
        </tr>
      </table>
      <!--  -->
      <br>
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>
        <span class="EndpointUrl">กรณีขนาดของตัวแปร title ที่ส่งมามีขนาดเกินที่กำหนด</span>
      </header>
      <code class="codecolormo">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageerror_title_range">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"title out of range"</span>
  }
      </code>
      <table id="apimsgtablemo" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>ขนาดของตัวแปร title ที่ส่งมามีขนาดเกินที่กำหนด
          </td>
        </tr>
      </table>
<!--  -->
      <br>
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>
        <span class="EndpointUrl">กรณีขนาดของตัวแปร detail ที่ส่งมามีขนาดเกินที่กำหนด</span>
      </header>
      <code class="codecolormo">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageerror_detail_range">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"detail out of range"</span>
  }
      </code>
      <table id="apimsgtablemo" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>ขนาดของตัวแปร detail ที่ส่งมามีขนาดเกินที่กำหนด
          </td>
        </tr>
      </table>
      <!--  -->
      <br>
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>
        <span class="EndpointUrl">กรณีขนาดของตัวแปร choice ที่ส่งมามีขนาดเกินที่กำหนด</span>
      </header>
      <code class="codecolormo">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageerror_choice_range">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"choice out of range"</span>
  }
      </code>
      <table id="apimsgtablemo" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>ขนาดของตัวแปร choice ที่ส่งมามีขนาดเกินที่กำหนด
          </td>
        </tr>
      </table>

      <!--  -->
      <br>
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>
        <span class="EndpointUrl">กรณีข้อมูลบางตัวของคีย์ elements มีข้อมูลไม่ครบ</span>
      </header>
      <code class="codecolormo">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageerror_missing_elements">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"elem missing parameter."</span>
  }
      </code>
      <table id="apimsgtablemo" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>ข้อมูลบางตัวของคีย์ elements มีข้อมูลไม่ครบ (เช็คคีย์ title detail choice ของแต่ละ Json ในคีย์ elements ว่าส่งมาครบหรือไม่)</td>
        </tr>
      </table>

      <!--  -->
      <br>
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>
        <span class="EndpointUrl">กรณีไม่พบ Url ใน choice ที่เป็นประเภท link หรือ webview</span>
      </header>
      <code class="codecolormo">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageerror_missing_url_choice">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"not found url in choice"</span>
  }
      </code>
      <table id="apimsgtablemo" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>ไม่พบ Url ใน choice ที่เป็นประเภท link หรือ webview
          </td>
        </tr>
      </table>


            <!--  -->
      <br>
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>
        <span class="EndpointUrl">กรณี Type ของ choice บางตัวที่ส่งมาไม่รองรับ</span>
      </header>
      <code class="codecolormo">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageerror_elmchoice_not_support">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"elem choice type not support"</span>
  }
      </code>
      <table id="apimsgtablemo" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>Type ของ choice บางตัวที่ส่งมาไม่รองรับ
          </td>
        </tr>
      </table>


    </div>
  </div>
<!-- </section> -->

</template>

<script>
import Navbar from '@/components/home/Navbar'
export default {
  components: {
    Navbar
  },
  data () {
    return {
      urlsendmsg: process.env.APIbc_template + '/v1/broadcast_group_template',
    //   /api/v1/broadcast_group_template
      message: '{\n\t"bot_id": "B6a84xxxa85f1fad2xxxxccfa703",\n\t"to": ["121xxx20x4","196xxxx23xx6"],\n\t"elements": [\n\t\t{\n\t\t\t"image" : "https://onechat.one.th/xxxxxxxxxxx.jpg" ,\n\t\t\t"detail": ""Pizza"",\n\t\t\t"title": "Pizza ถาดกลาง 250฿",\n\t\t\t"choice": [ \n\t\t\t\t{  \n\t\t\t\t\t"url" : "https://chat.one.th", \n\t\t\t\t\t"sign" : "true",\n\t\t\t\t\t"size" : "tall",\n\t\t\t\t\t"type" : "webview",\n\t\t\t\t\t"label" : "One Chat" \n\t\t\t\t}, \n\t\t\t\t{....รูปแบบปุ่มต่างๆ....} \n\t\t\t]   \n\t\t},\n\t\t...\n\t]\n}',
      messageresponse: '{\n\t"status":"success"\n}',
      messageerror_no_auth: '\nauthorization_fail\n',
      messageerror_wrong_auth: '{\n\t "status":"fail",  \n\t "message":"Authorization wrong format."  \n}',
      messageerror_fail_auth: '{\n\t "status":401,  \n\t "message":"authorization_failed"  \n}',
      messageerror_missing_parameter: '\ missing_parameter\n',
      messageerror_out_of_range: '{\n\t "status":"fail",  \n\t "message":"to out of range"  \n}',
      messageerror_no_botid: '{\n\t "status":"fail",  \n\t "message":"Not found bot."  \n}',
      messageerror_wrong_title: '{\n\t "status":"fail",  \n\t "message":"type title error"  \n}',
      messageerror_wrong_detail: '{\n\t "status":"fail",  \n\t "message":"type detail error"  \n}',
      messageerror_wrong_choice: '{\n\t "status":"fail",  \n\t "message":"type choice error"  \n}',
      messageerror_title_range: '{\n\t "status":"fail",  \n\t "message":"title out of range"  \n}',
      messageerror_detail_range: '{\n\t "status":"fail",  \n\t "message":"detail out of range"  \n}',
      messageerror_choice_range: '{\n\t "status":"fail",  \n\t "message":"choice out of range"  \n}',
      messageerror_missing_elements: '{\n\t "status":"fail",  \n\t "message":"elem missing parameter."  \n}',
      messageerror_missing_url_choice: '{\n\t "status":"fail",  \n\t "message":"not found url in choice"  \n}',
      messageerror_elmchoice_not_support: '{\n\t "status":"fail",  \n\t "message":"elem choice type not support"  \n}',
      urlexamplebtn: process.env.APIdevelop + '/docs/template/template_message'

      // messagetokenroomerror: '{\n\t"status": "fail",\n\t"message": "User ID not found."\n}',
      // messageboterror: '{\n\t"status": "fail",\n\t"message": "Bot ID not found."\n}',
      // messagetypeerror: '{\n\t"status": "fail",\n\t"message": "Type not support."\n}',
      // messageparametererror: '{\n\t"status": "fail",\n\t"message": "Parameter error."\n}',
      // messageauthoerror: '{\n\t"status": "fail",\n\t"message": "Authorization fail."\n}',
      // messagenotstring: '{\n\t"status": "fail",\n\t"message": "Value of message not support."\n}',
      // headermessage: '{\n\t"header": "Bearer 0nTblsxxx"}'
    }
  },
  methods: {
    gotopart () {
      this.$router.push('/docs/template/template_message')
    },
  },
  created () {
    // this.urlsendmsg = process.env.APIimage + '/api/v1/push_message'
    // this.urlsendmsg = process.env.APIbc_msg + '/api/v1/broadcast_group'
  }
}
</script>

<style type="text/css" scoped>
.codecolor {
  background: #2c3538;
  color: white;
  width: 40vw;
}
.codecolormo {
  background: #2c3538;
  color: white;
  width: 100%;
}
.colorkey {
  color:#65ef01;
}
.colorvalue {
  color:#ffee6a;
}
.preindent {
  text-indent: 2em;
}
._make-article {
    line-height: 1.5em;
    width: 90vw;
}
.ArticleMainTitle {
    margin-top: 0;
    font-size: 2.25rem;
    line-height: 1em;
}
._make-article h1, ._make-article h2, ._make-article h3, ._make-article h4, ._make-article h5, ._make-article h6 {
    margin-top: 32px;
    margin-bottom: 24px;
}
.EndpointHeader h2 {
  margin-top: 2vh;
    margin-bottom: 1vh;
}
.EndpointHeader {
    margin-top: 2vh;
    margin-bottom: 2vh;
}
.EndpointTitle {
    display: inline-block;
    margin: 0;
}
.EndpointVerbGet {
    /*position: relative;*/
    top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid #D5DDE5;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    border-color: #134fe0;
    background-color: #215CEC;
    color: #FFFFFF;
}
.EndpointVerbfail {
  top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid orange;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    /*border-color: #134fe0;*/
    background-color: orange;
    color: #FFFFFF;
}
.EndpointVerberror {
  top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid red;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    /*border-color: #134fe0;*/
    background-color: red;
    color: #FFFFFF;
}
.EndpointVerbPost {
    /*position: relative;*/
    top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid #D5DDE5;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    border-color: #3cb614;
    background-color: #44CD16;
    color: #FFFFFF;
}
.EndpointUrl {
    display: block;
    color: #6D7D8D;
}
#apimsgtable {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 40vw;
}

#apimsgtable td, #apimsgtable th {
    border: 1px solid #ddd;
    padding: 8px;
}

#apimsgtable tr:nth-child(even){background-color: #f2f2f2;}

#apimsgtable tr:hover {background-color: #ddd;}

#apimsgtable th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}

#apimsgtablemo {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 100%;
}

#apimsgtablemo td, #apimsgtablemo th {
    border: 1px solid #ddd;
    padding: 8px;
}

#apimsgtablemo tr:nth-child(even){background-color: #f2f2f2;}

#apimsgtablemo tr:hover {background-color: #ddd;}

#apimsgtablemo th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}
.requestmessage {
    display: none !important;
}

.codecolor:hover .requestmessage {
    display: block !important;
}

.urlcopymessage {

    display: none !important;
}
.EndpointUrl:hover .urlcopymessage {
    display: inline !important;
}
.requestmessageresponse{
    display: none !important;
}

.codecolor:hover .requestmessageresponse {
    display: block !important;
}

.wraplinkxs{
    word-wrap: break-word;
    width: 60px;
}
.wrap2{
  width:70px;
  white-space: pre-wrap; /* css-3 */
  white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
  white-space: -pre-wrap; /* Opera 4-6 */
  white-space: -o-pre-wrap; /* Opera 7 */
  word-wrap: break-word; /* Internet Explorer 5.5+ */
}

.wrap3{
  width:200px;
  white-space: pre-wrap; /* css-3 */
  white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
  white-space: -pre-wrap; /* Opera 4-6 */
  white-space: -o-pre-wrap; /* Opera 7 */
  word-wrap: break-word; /* Internet Explorer 5.5+ */
}
</style>



// WEBPACK FOOTER //
// src/components/home/api/webhook/templategroupwebhook.vue